import { authorizedServerFetch } from './server.actions';

export const switchUserCommunity = async (communityId) => {
  if (communityId) {
    const res = await authorizedServerFetch(
      `users/me/community/${communityId}`,
      {
        method: 'PUT',
      },
    );

    if (res.ok) {
      // window.location.pathname.startsWith('/organization/') ||
      // window.location.pathname.startsWith('/onboard/')
      if (!window.location.pathname.startsWith('/home')) {
        window.onbeforeunload = function () {
          window.setTimeout(function () {
            window.location = `${window.location.origin}/home`;
          }, 0);
          window.onbeforeunload = null;
        };
      }
      window.location.reload();
    } else {
      console.error('Error while changing community');
    }
  }
};
